import React, { useState, ReactElement } from 'react'
import FormGroup from 'live/components/forms/ui/form-group'

type Props = {
    value(initialValue: number): number
    onChange: (value: number) => void
    label: string
    dark: boolean
    isEditor: boolean
}

ChangeLimit.defaultProps = {
    label: 'Channel Limit',
    dark: true,
    isEditor: false,
    value: 0.01
}

export default function ChangeLimit(props: Props): ReactElement {
    const [value, setValue] = useState(props.value)

    function update(): void {
        props.onChange(parseFloat(value))
    }

    return (
        <FormGroup
            type="text"
            className={'dropdown-toggler--cancel-drag input-field'}
            label={props.label}
            value={value}
            onKeyDown={(e: KeyboardEvent) => (e.key === 'Enter' ? update() : null)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
            onBlur={update}
        />
    )
}
